import {isNullOrUndefined} from "../../../../services/Validator";
import ExerciserCorrectionAppreciationText
    from "../../../texts/courses/exercisers/ExerciserCorrectionAppreciationText";
import {MathJax, MathJaxContext} from "better-react-mathjax";
import {latexifyString} from "../../../../helpers/LatexHelper";

export default function ExerciserCorrectionUserAnswer({userSubmission}) {
    // Used in ExerciserCorrectionModal to display user
    // submission given answer

    // BUILD
    if (isNullOrUndefined(userSubmission?.answer) || isNullOrUndefined(userSubmission?.isCorrect))
        return null
    return (
        <div className={"mt-[24px] w-full flex flex-col justify-center items-center"}>
            <MathJaxContext>
                <MathJax inline dynamic>
                    <span className={`h-[64px] px-[12px] py-[6px] text-white text-[26px] border-[2px] rounded-[8px] ${computeUserAnswerStyle(userSubmission.isCorrect)}`}>
                        {latexifyString(userSubmission.answer)}
                    </span>
                </MathJax>
            </MathJaxContext>
            <ExerciserCorrectionAppreciationText isCorrect={userSubmission.isCorrect} />
        </div>
    );

    // METHODS
    // ---- Compute response style
    function computeUserAnswerStyle(isCorrect) {
        return isCorrect ? "border-primaryLight1" : "border-secondaryLight1"

    }
}